import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function CustomersPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/customers").then((r) => setItems(r.data.items)); }, []);
  return (
    <div className="space-y-5" data-testid="admin-customers-page">
      <div>
        <h1 className="font-display font-extrabold text-2xl text-gray-900">Customers</h1>
        <p className="text-sm text-gray-500 mt-1">{items.length} unique customers · derived from leads</p>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs text-gray-500 uppercase tracking-wider">
            <tr><th className="p-3 text-left">Name</th><th className="p-3 text-left">Phone</th><th className="p-3 text-left">Email</th><th className="p-3 text-left">Leads</th><th className="p-3 text-left">Sources</th><th className="p-3 text-left">First Seen</th><th className="p-3 text-left">Last Seen</th></tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {items.map((c) => (
              <tr key={c.phone} className="hover:bg-gray-50">
                <td className="p-3 font-semibold">{c.name}</td>
                <td className="p-3"><a href={`tel:${c.phone}`} className="text-[#940C2C]">{c.phone}</a></td>
                <td className="p-3 text-gray-700 text-xs">{c.email || "—"}</td>
                <td className="p-3"><span className="bg-gray-100 rounded px-2 py-0.5 text-xs font-bold">{c.leads}</span></td>
                <td className="p-3 text-xs">{(c.sources || []).join(", ")}</td>
                <td className="p-3 text-xs text-gray-500">{new Date(c.first_seen).toLocaleDateString()}</td>
                <td className="p-3 text-xs text-gray-500">{new Date(c.last_seen).toLocaleDateString()}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={7} className="p-10 text-center text-gray-400">No customers yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
